export class CashFlowSummary {
    /** Unique internal identity of the corporation associated with the summary. */
    public corporateId: number = 0;

    /** Name of the corporation associated with this summary. */
    public corporation: string;

    /** Unique internal identity of the lot associated with the summary. */
    public lotId: number = 0;

    /** Name of the lot associated with this summary. */
    public name: string;

    /** Street address of the lot associated with this summary. */
    public address: string;

    /** City. state and zip of the lot associated with this summary. */
    public cityStateZip: string;

    /** Dollar amount of bhph payments made for the given lot, coproatin and time frame. */
    public bhph: number = 0

    /** Dollar amount of late fee payments made for the given lot, coproatin and time frame. */
    public lates: number = 0

    /** Dollar amount of total principal paid that will affect the overall account receivables balance. */
    public principal: number = 0

    /** Dollar amount of bhph payments made with method cash. */
    public bhphCash: number = 0

    /** Number of bhph payments made with method cash. */
    public bhphCashCount: number = 0

    /** Dollar amount of bhph payments made with method credit or debit card. */
    public bhphCard: number = 0

    /** Number of bhph payments made with method credit or debit card. */
    public bhphCardCount: number = 0

    /** Dollar amount of bhph payments made with method ach checking or ach savings.  */
    public bhphAch: number = 0

    /** Number of bhph payments made with method ach checking or ach savings.  */
    public bhphAchCount: number = 0

    /** Dollar amount of bhph payments made with method other than those listed.  */
    public bhphOther: number = 0

    /** Number of bhph payments made with method other than those listed.  */
    public bhphOtherCount: number = 0

    /** Dollar amount of down payments received for bhph deals. */
    public downs: number = 0

    /** Dollar amount of down payment received for outside finance deals. */
    public downsOutside: number = 0

    /** Dollar amount of down payments made with method cash. */
    public downCash: number = 0

    /** Number of down payments made with method cash. */
    public downCashCount: number = 0

    /** Dollar amount of down payments made with method credit or debit card. */
    public downCard: number = 0

    /** Number of down payments made with method credit or debit card. */
    public downCardCount: number = 0

    /** Dollar amount of down payments made with method ach checking or ach savings. */
    public downAch: number = 0

    /** Number of down payments made with method ach checking or ach savings. */
    public downAchCount: number = 0

    /** Dollar amount of down payments made with method other than those listed. */
    public downOther: number = 0

    /** Number of down payments made with method other than those listed. */
    public downOtherCount: number = 0

    /** Dollar amount of deposit payments received for bhph deals. */
    public deposits: number = 0

    /** Dollar amount of deppsit payment received for outside finance deals. */
    public depositsOutside: number = 0

    /** Dollar amount of outside financed sales funding amounts. */
    public outside: number = 0

    /** Dollar amount of cash sale payments received. */
    public cash: number = 0

    /** Dopllar amount of wholesale payments received. */
    public wholesale: number = 0

    /** Dollar amount of cpi payments received. */
    public cpi: number = 0

    /** Dollar amount of after-sale (service) charges received. */
    public afterSale: number = 0

    /** Dollar amount of bounce charges received. */
    public bounce: number = 0

    /** Dollar amount of expected scheduled payments to be recived with the same time frame. */
    public scheduled: number = 0
}
